import type { BuildingConfig, BuildingStorageConfig } from '../../../config/gameConfig';
import type { SettlementBuilding, SettlementInventory } from '../types';

function createEmptyStorage(): SettlementInventory {
    return {
        food: 0,
        fish: 0,
        tools: [],
        planks: 0,
        wood: 0,
        stone: 0,
        bricks: 0,
        charcoal: 0,
        ironOre: 0,
        ironIngots: 0,
        fiber: 0,
        clothRope: 0,
        leather: 0,
        weapons: 0,
        goldOre: 0,
        coins: 0,
    };
}

function buildCapMap(
    storage: Record<string, BuildingStorageConfig> | undefined,
): Record<string, number> {
    if (!storage) return {};
    const caps: Record<string, number> = {};
    for (const [resource, entry] of Object.entries(storage)) {
        const max = Math.max(0, entry?.max ?? 0);
        const cap = entry?.cap ?? max;
        caps[resource] = Math.max(0, Math.min(cap, max));
    }
    return caps;
}

export function createSettlementBuilding(qty: number, config: BuildingConfig): SettlementBuilding {
    return {
        qty,
        storage: createEmptyStorage(),
        inputCap: buildCapMap(config.input),
        outputCap: buildCapMap(config.output),
    };
}
